import {createSelector} from "reselect";
import {IStore} from "modules/types/store";
import {ButtonType, RequestState} from "modules/enums";

export const getUserState = ({user}: IStore) => user;

export const isSessionChecked = createSelector(
	getUserState,
	({sessionCheckedState}) => sessionCheckedState === RequestState.Received
);

export const getUser = createSelector(getUserState, ({user}) => user);

export const getUserErrors = createSelector(getUserState, ({errors}) => errors);
export const getChangePasswordErrors = createSelector(
	getUserState,
	({changePasswordErrors}) => changePasswordErrors
);

export const getIsLoadingAuth = createSelector(
	getUserState,
	({requestState}) => requestState === RequestState.Requested
);

export const isLoggedIn = createSelector(getUser, (user) => Boolean(user));

export const getIsValidateTokenLoading = createSelector(
	getUserState,
	({tokenRequestState}) => tokenRequestState !== RequestState.Received
);

export const getRedirectUri = createSelector(getUserState, ({redirectUri}) => redirectUri);

export const getNavigateToUri = createSelector(getUserState, ({navigateToUri}) => navigateToUri);

export const getIsLoadingChangePassword = createSelector(
	getUserState,
	({changePasswordRequestState}) => changePasswordRequestState === RequestState.Requested
);

export const getIsLoadingLogout = createSelector(
	getUserState,
	({logoutRequestState}) => logoutRequestState === RequestState.Requested
);

export const getIsLoadingChangeAvatar = createSelector(
	getUserState,
	({changeAvatarRequestState}) => changeAvatarRequestState === RequestState.Requested
);

export const getIsShowChangedAvatarText = createSelector(
	getUserState,
	({changeAvatarButtonType}) => changeAvatarButtonType === ButtonType.Saved
);
